import styled from 'styled-components/macro';
import {
  Box,
  Button,
  COLORS,
  DarkMode,
  Heading,
  IconButton,
} from '@podiumhq/design-system';

import PodiumLogo from 'components/PodiumLogo';
import { MEDIUM_MEDIA_QUERY_WIDTH } from 'styles';
import { useExperiment } from '@podiumhq/tracking';

import EmailField from '../../components/FormFields/EmailField';
import PasswordField from '../../components/FormFields/PasswordField';
import useTrialAccountDetails from '../../hooks/useTrialAccountDetails';
import { TrialDisclaimer } from '../../layout';
import { handleCloseTrialModal } from '../../utils';
import { useTrialsContext } from 'contexts/TrialsContextProvider';

const CreateAccount = () => {
  const { handleSubmit, isInPodiumIframe, isSubmitting } =
    useTrialAccountDetails();

  const { setPromoAmplitudeExperiment } = useTrialsContext();
  const [, promoAmplitudeExperiment] = useExperiment('pr-di-ab-test');

  setPromoAmplitudeExperiment(promoAmplitudeExperiment);

  return (
    <DarkMode>
      <Box backgroundColor="black.base" height="100vh">
        {isInPodiumIframe && (
          <CloseButton>
            <IconButton
              onClick={handleCloseTrialModal}
              type="XClose"
              size="md"
              variant="ghost"
              fillColor="silver.light"
            />
          </CloseButton>
        )}

        <Content>
          <PodiumLogo icon={true} invert={true} />
          <Heading
            color="silver.lightest"
            fontSize="2xl"
            fontWeight="semibold"
            padding="24px 0"
          >
            Start your 14 day free trial
          </Heading>

          <EmailField isSubmitting={isSubmitting} />
          <PasswordField />

          <TrialDisclaimer mb="32px" />

          <Button
            fillColor="#1E47F6"
            id="trials-account-info-next-clicked"
            mb="32px"
            onClick={handleSubmit}
            size="lg"
            style={{
              display: 'block',
              width: '100%',
            }}
          >
            Start free trial
          </Button>
        </Content>
      </Box>
    </DarkMode>
  );
};

const Content = styled.div`
  width: 345px;
  margin-right: auto;
  margin-left: auto;
  padding-top: 22vh;
  height: 78vh;
  position: relative;

  @media (max-width: ${MEDIUM_MEDIA_QUERY_WIDTH}px) {
    padding-top: 4vh;
    height: 96vh;
  }
`;

const CloseButton = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  border-radius: 50px;
  align-items: center;
  margin-top: 32px;
  right: 32px;
  position: absolute;
  z-index: 1;

  :hover {
    cursor: pointer;

    button {
      background: ${COLORS.black.lighter};
      border: ${COLORS.black.lighter};
    }
  }

  button {
    background: ${COLORS.black.light};
    border: ${COLORS.black.light};
  }
`;

export default CreateAccount;
